export default __webpack_public_path__ + "static/media/folder.006fd540.svg";